import React, { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { FiEye, FiEyeOff } from 'react-icons/fi';
import { API_URLS } from '../../../config/api';
import './ResetPassword.css';

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [passwordErrors, setPasswordErrors] = useState([]);
  const [msg, setMsg] = useState('');
  const navigate = useNavigate();

  const validatePassword = (password) => {
    return [];
  };

  const handlePasswordChange = (value) => {
    setPassword(value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMsg('');
    if (!password || !confirmPassword) {
      setMsg('Please fill all fields');
      return;
    }
    if (password !== confirmPassword) {
      setMsg('Passwords do not match');
      return;
    }
    
    try {
      const res = await fetch(API_URLS.RESET_PASSWORD, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, password })
      });
      const data = await res.json();
      if (!res.ok) {
        setMsg(data.error || 'Error');
      } else {
        setMsg(data.message || 'Password changed!');
        setTimeout(() => navigate('/SignIn'), 1500);
      }
    } catch {
      setMsg('Server connection error');
    }
  };

  return (
    <div className="reset-container">
      <h2>Reset Password</h2>
      <form className="reset-form" onSubmit={handleSubmit}>
        <div className="input-group">
          <label htmlFor="password">New Password</label>
          <div className="password-wrapper">
            <input
              type={showPassword ? "text" : "password"}
              id="password"
              placeholder="New password"
              value={password}
              onChange={e => handlePasswordChange(e.target.value)}
            />
            <button
              type="button"
              className="password-toggle-btn"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? <FiEyeOff /> : <FiEye />}
            </button>
          </div>
        </div>
        <div className="input-group">
          <label htmlFor="confirmPassword">Confirm New Password</label>
          <div className="password-wrapper">
            <input
              type={showConfirmPassword ? "text" : "password"}
              id="confirmPassword"
              placeholder="Confirm new password"
              value={confirmPassword}
              onChange={e => setConfirmPassword(e.target.value)}
            />
            <button
              type="button"
              className="password-toggle-btn"
              onClick={() => setShowConfirmPassword(!showConfirmPassword)}
            >
              {showConfirmPassword ? <FiEyeOff /> : <FiEye />}
            </button>
          </div>
        </div>
        <button type="submit">Change Password</button>
        {msg && <div className="reset-msg">{msg}</div>}
      </form>
    </div>
  );
};

export default ResetPassword;
